import { render } from "./TreeItem.vue?vue&type=template&id=f28d7c04"
import script from "./TreeItem.vue?vue&type=script&lang=js"
export * from "./TreeItem.vue?vue&type=script&lang=js"

import "./TreeItem.vue?vue&type=style&index=0&id=f28d7c04&lang=scss"

import exportComponent from "/Users/anthony/Documents/APP/SIMEF LAST/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__